import { Component, OnInit, Output, EventEmitter, ViewChild, Input, SimpleChanges } from '@angular/core';
import { MatPaginator, MatDialog, MatSnackBar, MatSort } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { LearnerService } from '../../services/learner.service';
import { FilterService } from '../../services/filter.service';
import { NotificationService } from '../../services/notification.service';
import { NewFileModalComponent } from '../../files/new-file-modal/new-file-modal.component';
import { learnersAllStatus } from '../../_models/staticArray'
import { SharedService } from 'src/app/shared.service';
import { UserRoleService } from 'src/app/services/user-role.service';

@Component({
  selector: 'app-learner-submission',
  templateUrl: './learner-submission.component.html',
  styleUrls: ['./learner-submission.component.scss']
})
export class LearnerSubmissionComponent implements OnInit {

  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  displayedColumns: string[] = ['name', 'version', 'action'];
  disable: boolean;

  @Input('previousIndex') previousIndex: any;
  @Input('fileAllList') fileAllListData: any;
  @Input('assignment') assignmentData: any
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() openSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  courseType: any;
  sessionType: any;
  learnerId: any;
  sort: MatSort;
  job: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isTrainer: boolean = false;
  isIQA: boolean = false;

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }



  constructor(
    public _filter: FilterService,
    public dialog: MatDialog,
    private _learnerService: LearnerService,
    private activatedRoute: ActivatedRoute,
    private _sharedService: SharedService,
    public _snackBar: MatSnackBar,
    public _notificationService: NotificationService,
    public _userRoleService: UserRoleService
  ) {
    console.log("this.files 1 ", this.files);
    this.dataSource = new MatTableDataSource(this.files);

    this._sharedService.deletedFile.subscribe((res: any) => {
      if (res == undefined) return
      else {
        console.log("res get ", res);
        console.log("this.files 2 ", this.files);

        if (this.files && this.files.length)
          this.files.splice(this.files.findIndex(function (i) {
            return i._id === res.fileId;
          }), 1);
        console.log("this.files 3 ", this.files);
        // this.dataSource = new MatTableDataSource(this.files);
        this.updateData(this.files)
      }
    })

    this.activatedRoute.queryParams.subscribe((params) => {





      // if (window && window.history && window.history.state && window.history.state.job) {
      //   if (window.history.state.job && window.history.state.job.length)
      //     this.job = window.history.state.job[0]
      //   else if (window.history.state.job && !window.history.state.job.length)
      //     this.job = window.history.state.job
      //   console.log("get final result of the job ....", this.job)
      //   this.getUserRole()
      // }
    })
    // console.log("this.files", this.files);
    // this.dataSource = new MatTableDataSource(this.files);
  }
  placeholder = "Due date"
  allotmentId: any;
  loading: Boolean = false;
  assignment;
  learner;
  files = [];
  metiralFileList = []
  copyFiles = [];
  statusToChange;
  currentUser;
  isDisabled = true;
  statusByInstructor;
  remark;
  deadlineDate;
  hideActions = false;
  user;
  isUpload = false;
  // previousIndex
  // remark = new FormGroup({
  //   remark: new FormControl(),
  //   deadlineDate: new FormControl(),
  //   status: new FormControl()
  // });

  allStatus = learnersAllStatus
  // [
  //   { id: 1, name: 'Requested for Resubmission' },
  //   { id: 1, name: 'Completed' }
  // ]
  olderRemarks = [
    // {date:'01/02/2020',text: 'This is a demo remark'},
    // { date: '10/03/2020', text: 'This is a demo remark which is longer than the last remark' },
    // { date: '15/03/2020', text: 'This is a remark' }
  ]

  ngOnInit() {
    // this.loading = true;

    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user details", this.user);

    this.activatedRoute.queryParams.subscribe(qparam => {
      console.log('qparam', qparam);
      if (qparam.courseType == 'Level2') {
        this.courseType = qparam.courseType,
          this.sessionType = qparam.sessionType
        if (qparam.learnerId) {
          this.learnerId = qparam.learnerId
        }
      }

      if (qparam && qparam.userRole) {
        let getRole = qparam.userRole
        console.log("value of query params", qparam, getRole);
        if (getRole == 0) this.isAdmin = true
        else if (getRole == 1) this.isTrainer = true
        else if (getRole == 2) this.isIQA = true
        else if (getRole == 3) this.isLearner = true
        // else this.isIQA = false
      }
    })
    this.activatedRoute.params.subscribe(params => {
      console.log(params['id']);
      this.allotmentId = params['id'];
      // this.getAllotments(this.allotmentId)
    });

    if (this.courseType == 'Level2') {
      let data = {
        sessionType: this.sessionType,
        tempKey: this.allotmentId,
        learnerId: this.learnerId,
        status: this.statusToChange
      }
      // this.getSessionSubmission(data)
    }
    else {
      // this.getAllotments(this.allotmentId)
    }


    if (this.user.isLearner) {
      this.isDisabled = false;
    }
    else if (this.user.isClient) {
      this.hideActions = true;
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("what is the chnges of status", changes);

    if (changes.assignmentData && changes.assignmentData.currentValue) {
      this.assignment = changes.assignmentData.currentValue
      this.olderRemarks = this.assignment.remark
      console.log('this.oldRemark = ', this.olderRemarks)
      this.deadlineDate = this.assignment.deadlineDate

      if (this.assignment.status == 'Pending') {
        this.statusToChange = 'Submitted'
      } else {
        this.statusToChange = 'Re-submitted'
      }

      this.files = this.assignment.learnerFiles;
      this.copyFiles = this.files;
      this.updateData(this.files)
      // this.dataSource = new MatTableDataSource(this.files);
    }


    // if (changes.fileAllListData && changes.fileAllListData.currentValue) {
    //    this.metiralFileList=changes.fileAllListData.currentValue;
    // }


  }




  // UTILITY

  updateData(files) {
    console.log("UPDATING DATA = ", files)
    console.log("Emitting event getLearnersFromComponent with learners = ", files);
    // this.getLearnersFromComponent.emit({ learners })
    this.dataSource = new MatTableDataSource(files);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item=====>>>>>", item);
      console.log("property=====>>>>>", property);

      switch (property) {
        case 'name': return item.title
        case 'version': return item.version;
        default: return item[property];
      }
      // return item
    };
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;

  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.job.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { width: "1000px", data });
    return dialogRef.afterClosed();
  }

  addFileModal() {
    console.log('this.allotmentId', this.allotmentId, 'this.sessionType', this.sessionType)
    let data;
    if (!this.courseType) {
      data = {
        allotmentId: this.allotmentId,
        status: this.statusToChange,
        isSubmission: true
      }
    }
    else {
      data = {
        sessionType: this.sessionType,
        tempKey: this.allotmentId,
        learnerId: this.currentUser._id,
        status: this.statusToChange,
        isSubmission: true
      }
    }
    console.log('DATA', data)
    let addedCourse = this.openDialog(NewFileModalComponent, data).subscribe((courses) => {
      console.log("Course added in controller = ", courses);
      if (!this.courseType) {
        this.getAllotments(this.allotmentId)
      }
      this.sendPushNotification()
    }, err => {
      this.openSnackBar("Something went wrong!", "Ok");
    });
  }


  sendPushNotification() {

    this._notificationService.sendPushNotificationToStaff(this.allotmentId).subscribe((res) => {
      console.log("respions of send push notification to user", res);

    }, err => {
      console.log("error", err);

    })

  }


  singleFileDetails(file) {
    console.log("single file details", file);
    // file['name'] = this.assignment.assignment.title
    file['type'] = "material"
    file['isSubmission'] = true
    this.openFilesSideNav.emit({ file: file, name: this.assignment.assignment.title })
  }



  // API CALL

  submit() {
    console.log('this.statusByInstructor', this.statusByInstructor);
    console.log('this.remark', this.remark);
    console.log('allotmentId', this.allotmentId);
    console.log('deadlineDate', this.deadlineDate);
    if (!this.courseType) {
      let data = {
        allotmentId: this.allotmentId,
        status: this.statusByInstructor,
        remark: this.remark,
        deadlineDate: this.deadlineDate
      }
      if (this.statusByInstructor) {
        console.log("final data to be update", data);

        this.loading = true;
        this._learnerService.updateAssignmentAllotmentUsingAllotmentId(data).subscribe(data => {
          this.getAllotments(this.allotmentId)
          if (this.statusByInstructor == 'Completed') {
            this.openSnackBar("Assignment marked as completed!", "Ok");
          } else {
            this.openSnackBar("Assignment requested for resubmission!", "Ok");
          }
          this.loading = false;
        }, err => {
          this.loading = false;
          this.openSnackBar("Something went wrong!", "Ok");
        })
      }
      else {
        this.openSnackBar("Please select a status", "Ok");
      }
    }
    else {
      let data = {
        sessionId: this.allotmentId,
        sessionType: this.sessionType,
        learnerId: this.learnerId,
        status: this.statusByInstructor,
        remark: this.remark,
        tempKey: this.allotmentId,
      }
      if (this.statusByInstructor) {
        console.log("DATA", data);
        // this.loading = true;
        // this._learnerService.updateSessionSubmission(data).subscribe(rea => {
        //   this.getSessionSubmission(data)
        //   if (this.statusByInstructor == 'Completed') {
        //     this.openSnackBar("Assignment marked as completed!", "Ok");
        //   } else {
        //     this.openSnackBar("Assignment requested for resubmission!", "Ok");
        //   }
        //   this.loading = false;
        // }, err => {
        //   this.openSnackBar("Something went wrong!", "Ok");
        // })
      }
      else {
        this.openSnackBar("Please select a status", "Ok");
      }
    }



  }
  fileDetails(event) {
    event['name'] = this.assignment.assignment.title
    console.log("Event in material-files", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit(event)
  }


  getAllotments(allotmentId) {
    console.log('Get Allotments Called', allotmentId);
    this._learnerService.getAllotedLearnerFilesUsingAllotmentId(allotmentId).subscribe(data => {
      console.log("learner data of allotment", data);

      this.assignment = data[0];
      this.loading = false;
      this.learner = data[0].learner;
      console.log('this.assignment----------', this.assignment);
      this.olderRemarks = this.assignment.remark
      console.log('this.oldRemark = ', this.olderRemarks)
      this.deadlineDate = this.assignment.deadlineDate
      this.remark = ''
      this.statusByInstructor = ''
      // if (this.assignment.remark) {

      // } else {
      //   this.assignment.remark = 'No Remarks'
      // }

      if (this.assignment.status == 'Pending') {
        this.statusToChange = 'Submitted'
      } else {
        this.statusToChange = 'Re-submitted'
      }

      this.files = data[0].learnerFiles;
      this.copyFiles = this.files;
      this.updateData(this.files);
      // this.dataSource = new MatTableDataSource(this.files);
    });
  }

  getSessionSubmission(data) {
    console.log("data for getting learners submissions", data);

    this._learnerService.getSessionSubmission(data.tempKey, data.sessionType, data.learnerId).subscribe(res => {
      console.log('GOT LEARNER DATA', res)
      this.assignment = res[0];
      this.learner = res[0].learner;
      this.olderRemarks = res[0].remark
      if (this.assignment.status == null) {
        this.statusToChange = 'Submitted'
      } else {
        this.statusToChange = 'Re-submitted'
      }

      this.files = res[0].files;
      this.copyFiles = this.files;
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onChange(value) {
    this.deadlineDate = value;

  }


  applyFilter(filterValue: string) {
    this.loading = false;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
    if (filterValue == " " || filterValue == null || filterValue == "") {
      this.files = this.copyFiles
    }
    else {
      this.files = this._filter.filter(filterValue, this.copyFiles, ['title', 'type']);
    }
  }

  deletedFile(event) {
    this.openSnackBar("File deleted successfully!", "Ok");
    console.log("File Deleted Event : ", event);
    this.files.splice(this.files.findIndex(function (i) {
      return i._id === event._id;
    }), 1);
  }

}
